import { hasVerifiedPayment } from "components/ModuleInvoice/moduleInvoiceRules";
import { isModuleInvoice } from "components/ModuleInvoice/moduleLinks";

// A module invoice's rights come from the server, which applies its paid lock; nothing is re-derived here.
const moduleRight = (invoice) => invoice.moduleCanEdit === true;

export const canEditClientInvoice = (invoice, canCreate) =>
  isModuleInvoice(invoice) ? moduleRight(invoice) : canCreate;

export const canDeleteClientInvoice = (invoice, canCreate) =>
  isModuleInvoice(invoice) ? moduleRight(invoice) : canCreate && !hasVerifiedPayment(invoice);
